import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { useLang, useL } from "@/lib/i18n";
import { api, money } from "@/lib/api";
import { Card } from "./ui";

function K({ label, value, testId }) {
  return (
    <div className="panel p-5" data-testid={testId}>
      <p className="font-mono text-[11px] uppercase tracking-widest text-slate-500">{label}</p>
      <p className="mt-2 font-display text-4xl text-white">{value}</p>
    </div>
  );
}

export default function AdminOverview() {
  const { lang } = useLang();
  const L = useL();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-slate-500">…</p>;
  const services = [
    [L("Paiements Stripe (abonnements récurrents)", "Stripe payments (recurring subscriptions)"), s.stripe_connected,
      s.stripe_connected
        ? L("Connecté en MODE TEST (compte Stripe dédié au studio). Paiements réels désactivés jusqu'à votre confirmation.", "Connected in TEST MODE (dedicated studio Stripe account). Live payments off until you confirm.")
        : L("Compte Stripe du studio à connecter (mode test d'abord).", "Studio Stripe account must be connected (test mode first).")],
    [L("Courriels (confirmations, rappels, annulations, liste d'attente)", "Emails (confirmations, reminders, cancellations, waitlist)"), true, L("Actif via Resend géré par Emergent.", "Active via Emergent-managed Resend.")],
    [L("Portes / cartes d'accès (matériel)", "Doors / keycards (hardware)"), false,
      L("Gestion manuelle. Le site n'ouvre ni ne désactive aucune porte physique.", "Manual management. The website does not open or disable any physical door.")],
  ];
  return (
    <div className="space-y-6" data-testid="admin-overview">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <K label={L("Membres actifs", "Active members")} value={s.active_members} testId="stat-active-members" />
        <K label={L("Revenus du mois", "Revenue this month")} value={money(s.revenue_month, lang)} testId="stat-revenue-month" />
        <K label={L("Revenu mensuel estimé", "Est. monthly recurring")} value={money(s.mrr_estimate, lang)} testId="stat-mrr" />
        <K label={L("Heures réservées (mois)", "Hours booked (month)")} value={`${s.booked_hours_month} h`} testId="stat-booked-hours" />
        <K label={L("Taux d'occupation", "Utilization")} value={`${s.utilization_pct}%`} testId="stat-utilization" />
        <K label={L("Sessions à venir", "Upcoming sessions")} value={s.upcoming_sessions} testId="stat-upcoming" />
        <K label={L("Liste d'attente", "Waitlist")} value={s.waitlist_waiting} testId="stat-waitlist" />
        <K label={L("Ventes", "Sales")} value={s.capacity.sales_open ? L("Ouvertes", "Open") : L("Fermées", "Closed")} testId="stat-sales" />
      </div>
      <Card title={L("Utilisation — 14 jours", "Usage — 14 days")}>
        <div className="h-56">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={s.daily_usage}>
              <XAxis dataKey="date" stroke="#64748b" fontSize={11} />
              <YAxis stroke="#64748b" fontSize={11} allowDecimals={false} />
              <Tooltip contentStyle={{ background: "#0f1015", border: "1px solid #222" }} />
              <Bar dataKey="hours" fill="#e50914" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
      <Card title={L("Services et connexions", "Services & connections")} testId="services-status">
        <ul className="space-y-3">
          {services.map(([name, ok, note]) => (
            <li key={name} className="flex gap-3 rounded-lg border border-white/10 p-3">
              {ok ? <CheckCircle2 className="shrink-0 text-emerald-400" size={20} /> : <AlertTriangle className="shrink-0 text-amber-400" size={20} />}
              <div><p className="text-sm text-white">{name}</p><p className="text-xs text-slate-400">{note}</p></div>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
